"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _actionUtils = require("../../../utils/actionUtils");
var _syncBackgroundStatus = _interopRequireDefault(require("../../../actions/background/syncBackgroundStatus"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function backgroundLiveToggled(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var backgroundId = _ref2.backgroundId,
    notifyingDirector = _ref2.notifyingDirector;
  if (!(0, _actionUtils.isSameAttendee)(notifyingDirector, getState())) {
    dispatch((0, _syncBackgroundStatus["default"])(backgroundId));
  }
}
var _default = exports["default"] = backgroundLiveToggled;